import { useQuery } from "@tanstack/react-query";
import { client } from "../clients";

const fetchReportsDropdown = async ({ query = {} }) => {
  return client("/consent_summary", {
    method: "POST",
    data: query,
  }).then((data: any) => data);
};

const useReportsDropdown = ({ query = {}, options }: any = {}) => {
  return useQuery({
    queryKey: ["consent-summary", query],
    queryFn: () => fetchReportsDropdown({ query }),
    ...options,
  }) as any;
};

const fetchFiltersDropdown = async ({ query = {} }) => {
  return client("/consent_filters", {
    method: "POST",
    data: query,
  }).then((data: any) => {
    return data.data;
  });
};

const useFiltersDropdown = ({ query = {}, options }: any = {}) => {
  return useQuery({
    queryKey: ["consent_filters", query],
    queryFn: () => fetchFiltersDropdown({ query }),
    staleTime: 1000 * 60 * 30,
    gcTime: 1000 * 60 * 30,
    ...options,
  }) as any;
};

export { useReportsDropdown, useFiltersDropdown };
